<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
           unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
           active-text-color="#ffd04b">
    <div class="logobox" @click="goHome">
      锦胜雾森后台管理系统
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid"
                      @click="getUrl(chmenu.menuname,chmenu.url)">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = [
      {
        menuid: 1,
        icon: 'li-icon-xiangmuguanli',
        menuname: '系统设置',
        url: null,
        menus: [
          {
            menuid: 2,
            icon: 'icon-cat-skuQuery',
            menuname: '基本设置',
            url: 'basicSetting/index',
            menus: null
          }, {
            menuid: 3,
            icon: 'icon-cat-skuQuery',
            menuname: '广告设置',
            url: 'ad/index',
            menus: null
          },
        ]
      },
      {
        menuid: 6,
        icon: 'icon-cms-manage',
        menuname: '权限管理',
        url: null,
        menus: [
          {
            menuid: 7,
            icon: 'icon-cms-manage',
            menuname: '用户组管理',
            url: 'auth/userGroup',
            menus: null
          }, {
            menuid: 8,
            icon: 'icon-cms-manage',
            menuname: '管理员管理',
            url: 'auth/manager',
            menus: null
          }, {
            menuid: 9,
            icon: 'icon-cms-manage',
            menuname: '菜单管理',
            url: 'auth/menu',
            menus: null
          },
        ]
      },
      {
        menuid: 10,
        icon: 'li-icon-dingdanguanli',
        menuname: '系统消息',
        url: null,
        menus: [
          {
            menuid: 11,
            icon: 'icon-order-manage',
            menuname: '系统公告',
            url: 'notice/index',
            menus: null
          }
        ]
      }, {
        menuid: 12,
        icon: 'li-icon-dingdanguanli',
        menuname: '管理员管理',
        url: null,
        menus: [
          {
            menuid: 13,
            icon: 'icon-order-manage',
            menuname: '管理员白名单列表',
            url: 'auth/white',
            menus: null
          }
        ]
      }, {
        menuid: 14,
        icon: 'li-icon-dingdanguanli',
        menuname: '设备管理',
        url: null,
        menus: [
          {
            menuid: 15,
            icon: 'icon-order-manage',
            menuname: '设备分布',
            url: 'spread/index',
            menus: null
          }, {
            menuid: 16,
            icon: 'icon-order-manage',
            menuname: '设备列表',
            url: 'generalDevice/index',
            menus: null
          }, {
            menuid: 17,
            icon: 'icon-order-manage',
            menuname: '4G气象列表',
            url: 'weatherDevice/index',
            menus: null
          },
        ]
      },
      {
        menuid: 18,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '协议/教程管理',
        url: null,
        menus: [
          {
            menuid: 19,
            icon: 'icon-provider-manage',
            menuname: '协议',
            url: 'protocal/index',
            menus: null
          },
          {
            menuid: 20,
            icon: 'icon-provider-manage',
            menuname: '教程列表',
            url: 'course/index',
            menus: null
          }
        ]
      },
      {
        menuid: 24,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '报警列表',
        url: null,
        menus: [
          {
            menuid: 25,
            icon: 'icon-provider-manage',
            menuname: '报警信息列表',
            url: 'alarm/index',
            menus: null
          }
        ]
      },
      {
        menuid: 27,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '设备操作日志',
        url: null,
        menus: [
          {
            menuid: 28,
            icon: 'icon-provider-manage',
            menuname: '设备操作日志列表',
            url: 'log/index',
            menus: null
          }
        ]
      },
      {
        menuid: 29,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '微信用户管理',
        url: null,
        menus: [
          {
            menuid: 30,
            icon: 'icon-provider-manage',
            menuname: '微信用户列表',
            url: 'wechatUser/index',
            menus: null
          }, {
            menuid: 31,
            icon: 'icon-provider-manage',
            menuname: '全部管理员',
            url: 'wechatManager/index',
            menus: null
          },
        ]
      },
      {
        menuid: 33,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '售后维修/维保管理',
        url: null,
        menus: [
          {
            menuid: 34,
            icon: 'icon-provider-manage',
            menuname: '售后维修/维保列表',
            url: 'repair/repair',
            menus: null
          }
        ]
      },
      {
        menuid: 35,
        icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        menuname: '接口授权管理',
        url: null,
        menus: [
          {
            menuid: 36,
            icon: 'icon-provider-manage',
            menuname: '接口授权列表',
            url: 'apiAuth/index',
            menus: null
          }
        ]
      }
    ];
    this.allmenu = res
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },
  methods: {
    goHome(){
      this.$router.push('/home/index');
    },
    getUrl(name, url) {
      const data = {menuname: name, url: url};
      this.$emit('send', data);
    }
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue